export class DialogResult {
  static readonly Cancel = 0;
  static readonly Confirm = 1;
  static readonly AdditionalButton = 2;
  static readonly TertiaryButton = 3;
  static readonly Error = -1;
  static readonly Success = 99;
  resultCode: number;
  resultMessage: string;
  data: any;

  constructor(resultCode?: number) {
    this.resultCode = resultCode ?? DialogResult.Success;
  }
}
